module.exports = "/virtual-football-league/img/amblems/left/logos/Dortmund.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Dortmund.png
// module id = 2065
// module chunks = 4